export const blockIconsEditorFormatListNumbered = (
	<span className='material-symbols-outlined'>format_list_numbered</span>
);
